import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d31c8b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "path-style-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "solid"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "short-dash" }, null, -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "short-dash" }, null, -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "short-dot" }, null, -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "short-dot" }, null, -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "short-dot" }, null, -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "solid" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" 실선 "),
    ($setup.lineStyle === $setup.NaveMapPolyLineStyle.SOLID)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
      : ($setup.lineStyle === $setup.NaveMapPolyLineStyle.SHORT_DASH)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createCommentVNode(" 끊긴선 "),
            _hoisted_3,
            _hoisted_4
          ], 64 /* STABLE_FRAGMENT */))
        : ($setup.lineStyle === $setup.NaveMapPolyLineStyle.SHORT_DOT)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createCommentVNode(" 점선 "),
              _hoisted_5,
              _hoisted_6,
              _hoisted_7
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createCommentVNode(" 그 외 "),
              _hoisted_8
            ], 64 /* STABLE_FRAGMENT */))
  ]))
}